import React from 'react';




export const HouseTypeSelector = ({ handleInputChange, inputData }) => {
    return (
        <>

                <label htmlFor="house_type">House Type:</label>
                <select 
                    name="house_type" 
                    id="house_type" 
                    onChange={handleInputChange} 
                    value={inputData.house_type}
                    className="form-select">
                    <option value="Detached">Detached</option>
                    <option value="Semi-detached">Semi-Detached</option>
                    <option value="Terraced">Terraced</option>
                    <option value="Flat">Flat</option>
                </select>
                </>
    );
};


export const FloorAreaSelector = ({ handleInputChange, inputData }) => {
    return (
        <input
            type="range"
            id="TOTAL_FLOOR_AREA"
            name="TOTAL_FLOOR_AREA"
            min="10"
            max="350"
            value={inputData.TOTAL_FLOOR_AREA}
            onChange={handleInputChange}
            className="form-range"
        />
    );
}




